import { Modal, Button, Divider } from "antd";
import * as React from "react";
import { Layout, Input, Select, Row, Checkbox } from "antd";
import { Formik, FieldProps, Field } from "formik";
import * as moment from "moment";
import styled from "styled-components";
import * as la from "lodash";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { MODULES, ROLES } from "../../constant/comman";

const { Content } = Layout;
const Option = Select.Option;

const PermissionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 16px;
`;

const PermissionCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #d9d9d9;
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  gap: 10px;

  strong {
    font-size: 15px;
    color: #262626;
  }

  .ant-checkbox-wrapper {
    white-space: nowrap;
  }
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const GlobalToggleContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const QuickButton = styled(Button)`
  font-size: 13px !important;
  border-radius: 4px !important;
`;

export class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      selectedType: "",
      errors: {},
    };
  }

  input;
  permissionsData = {};

  allTypes = [
    <Option value={"subAdmin"} key="subAdmin">
      Sub Admin
    </Option>,
    <Option value={"superAdmin"} key="superAdmin">
      Super Admin
    </Option>,
  ];

  /**
   * set initial permission false for the sub admin user in below format for the defined modules
   * with defined actions in constant
   *
   * FORMAT: dashboard(module_name): { view(role_name): false, create: false, edit: false, delete: false },
   */
  setInitialPermission = (adminType = "subAdmin") => {
    MODULES.map((moduleName) =>
      ROLES[moduleName.value].map(
        (roleName) =>
        (this.permissionsData[moduleName.value] = {
          ...this.permissionsData[moduleName.value],
          [roleName.toLowerCase()]: adminType === "superAdmin" ? true : false,
        })
      )
    );
  };

  validateForm(values) {
    const errors = {};
    console.log("Validating form -- ", values);

    // if (!values.username) {
    //   errors.username = "username is required";
    // }

    if (!values.email) {
      errors.email = "email is required";
    }

    if (!values.first_name) {
      errors.first_name = "first name is required";
    }

    if (!values.last_name) {
      errors.last_name = "last name is required";
    }

    console.log("Validating errors -- ", errors);

    return errors;
  }

  handleSubmit = async (values, action) => {
    console.log(this.props._id);
    values.role = this.state.selectedType || this.props.data.role;
    this.props.onSubmit(values, this.props.data._id);
    this.setState({
      visible: false,
    });
  };

  changeType = (value) => {
    this.setState({
      selectedType: value,
    });
    this.setInitialPermission(value);
  };

  handleToggleModule = (moduleValue, isChecked, setFieldValue, values) => {
    const roles = ROLES[moduleValue] || [];
    const modulePermissions = { ...(values.permissions && values.permissions[moduleValue]) };
    roles.forEach((roleName) => {
      modulePermissions[roleName.toLowerCase()] = isChecked;
    });
    setFieldValue(`permissions.${moduleValue}`, modulePermissions);
  };

  handleToggleAll = (isChecked, setFieldValue, values) => {
    const updatedPermissions = { ...values.permissions };
    MODULES.filter((m) => m.value !== "dashboard").forEach((moduleName) => {
      const roles = ROLES[moduleName.value] || [];
      updatedPermissions[moduleName.value] = { ...updatedPermissions[moduleName.value] };
      roles.forEach((roleName) => {
        updatedPermissions[moduleName.value][roleName.toLowerCase()] = isChecked;
      });
    });
    setFieldValue("permissions", updatedPermissions);
  };

  isModuleAllChecked = (moduleValue, values) => {
    const roles = ROLES[moduleValue] || [];
    if (!values.permissions || !values.permissions[moduleValue]) return false;
    return roles.every((roleName) => values.permissions[moduleValue][roleName.toLowerCase()]);
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
      selectedType: "",
    });
  };

  render() {
    const { primaryColor, data } = this.props;
    return (
      <div>
        <Formik
          initialValues={{
            // username: data.username,
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            phone: data.phone,
            // password: data.password,
            permissions: data.permissions,
          }}
          validate={this.validateForm}
          onSubmit={this.handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            dirty,
          }) => {
            const isEdited = dirty || (this.state.selectedType !== "" && this.state.selectedType !== data.role);
            return (
              <div>
                <div className="formik-field_wrap">
                  {/* <div className="formik-field-left">
                    Username
                        <Input
                      id="username"
                      placeholder="Username"
                      value={values.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.username && touched.username ? (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          margin: "0",
                        }}
                      >
                        {errors.username}
                      </p>
                    ) : null}
                  </div> */}

                  <div className="formik-field-left">
                    First Name
                    <Input
                      id="first_name"
                      placeholder="First Name"
                      value={values.first_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.first_name && touched.first_name ? (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          margin: "0",
                        }}
                      >
                        {errors.first_name}
                      </p>
                    ) : null}
                  </div>

                  <div className="formik-field-right">
                    Last Name
                    <Input
                      id="last_name"
                      placeholder="Last Name"
                      value={values.last_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.last_name && touched.last_name ? (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          margin: "0",
                        }}
                      >
                        {errors.last_name}
                      </p>
                    ) : null}
                  </div>
                </div>

                <div className="formik-field_wrap">
                  <div className="formik-field-left">
                    Email
                    <Input
                      id="email"
                      placeholder="Email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.email && touched.email ? (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          margin: "0",
                        }}
                      >
                        {errors.email}
                      </p>
                    ) : null}
                  </div>

                  <div className="formik-field-right">
                    Phone
                    <Input
                      id="phone"
                      placeholder="Phone"
                      value={values.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.phone && touched.phone ? (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          margin: "0",
                        }}
                      >
                        {errors.phone}
                      </p>
                    ) : null}
                  </div>
                </div>

                <div className="formik-field_wrap">
                  <div className="formik-field-left">
                    Admin Type
                    <select
                      id="role"
                      style={{
                        width: "100%",
                        height: "38px",
                        borderRadius: "5px",
                        border: "1px solid #d9d9d9",
                        padding: "0 11px",
                        outline: "none",
                        backgroundColor: "#fff",
                        cursor: "pointer",
                      }}
                      value={this.state.selectedType || data.role || ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        this.changeType(val);
                        setFieldValue("permissions", this.permissionsData);
                      }}
                    >
                      <option value="" disabled>Select Admin Type</option>
                      <option value="subAdmin">Sub Admin</option>
                      <option value="superAdmin">Super Admin</option>
                    </select>
                    {this.state.errors.selectedAdminType ? (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          margin: "0",
                        }}
                      >
                        {this.state.errors.selectedAdminType}
                      </p>
                    ) : null}
                  </div>
                </div>

                {((this.state.selectedType || data.role) === "subAdmin") && (
                  <div style={{ marginTop: "24px" }}>
                    <div style={{ marginBottom: "8px" }}>
                      <strong style={{ fontSize: "16px", color: "#333" }}>Permissions Configuration</strong>
                    </div>
                    <GlobalToggleContainer>
                      <QuickButton
                        size="small"
                        onClick={() => this.handleToggleAll(true, setFieldValue, values)}
                        style={{ background: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959" }}
                      >
                        Grant All Permissions
                      </QuickButton>
                      <QuickButton
                        size="small"
                        onClick={() => this.handleToggleAll(false, setFieldValue, values)}
                        style={{ background: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959" }}
                      >
                        Revoke All Permissions
                      </QuickButton>
                    </GlobalToggleContainer>
                    <PermissionsGrid>
                      {MODULES.filter((m) => m.value !== "dashboard").map((moduleName, moduleIndex) => {
                        const allChecked = this.isModuleAllChecked(moduleName.value, values);
                        return (
                          <PermissionCard key={moduleIndex}>
                            <CardHeader>
                              <strong>{moduleName.label}</strong>
                              <Checkbox
                                checked={allChecked}
                                onChange={(e) => this.handleToggleModule(moduleName.value, e.target.checked, setFieldValue, values)}
                                style={{ fontSize: "12px", color: "#8c8c8c" }}
                              >
                                Select All
                              </Checkbox>
                            </CardHeader>
                            <CardBody>
                              {ROLES[moduleName.value] && ROLES[moduleName.value].map(
                                (roleName, roleIndex) => (
                                  <div key={roleIndex}>
                                    <Checkbox
                                      onChange={handleChange}
                                      checked={
                                        values.permissions &&
                                        values.permissions[moduleName.value] &&
                                        values.permissions[moduleName.value][
                                        roleName.toLowerCase()
                                        ]
                                      }
                                      name={`permissions.${moduleName.value}.${roleName.toLowerCase()}`}
                                    >
                                      {roleName}
                                    </Checkbox>
                                  </div>
                                )
                              )}
                            </CardBody>
                          </PermissionCard>
                        );
                      })}
                    </PermissionsGrid>
                  </div>
                )}

                <Button
                  type="primary"
                  style={{
                    marginTop: "19px",
                    background: isEdited ? "#5C6AC4" : "#cccccc",
                    borderColor: isEdited ? "#5C6AC4" : "#cccccc",
                    color: "#fff",
                    cursor: isEdited ? "pointer" : "not-allowed",
                  }}
                  disabled={!isEdited}
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              </div>
            );
          }}
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

export default connect(mapStateToProps)(withRouter(EditForm));
